import {FastField} from "formik";
import {FormGroup} from "../../../form/group";
import {Switch} from "../../../form/switch/Switch";
import * as React from "react";

interface Props {
  name: string;
  title: string;
  help?: string;
  setValue: (name: string, value: boolean) => void;
}

export const FastFieldSwitch = ({ name, title, help, setValue }: Props) => (
  <FastField
    name={name}
    render={({ field }: any) => (
      <FormGroup title={title} help={help}>
        <Switch
          id={`${name}-field-switch`}
          checked={field.value}
          onChange={(e) => setValue(name, e.target.checked)}/>
      </FormGroup>
    )}
  />
);
